module.exports = {
  environment: "production",
  backendApiUrl: "https://api.jibber.social",
};



// WEBPACK FOOTER //
// ./ENV.js